/* eslint-disable react/display-name */
import * as React from 'react';

const CountryFr = () => (
  <>
    <svg
      version="1.1"
      id="Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 60 60"
      xmlSpace="preserve"
    >
      <g>
        <path
          className="st0"
          d={`M4.2,19C3.9,18.1,4,17.5,5,17.3c0.9-0.2,1.7-0.7,2.6-0.1c0.2-0.7,1.4,0.4,1.5-0.7c0-0.3,1.9-0.3,2.2,0
          c0.2,0.2,0.4,0.5,0.5,0.8c0.3,0.8,0.7,1.4,1.5,0.4c0.2-0.2,0.5-0.4,0.8-0.1c0.3,0.4,0.6,0.2,1,0.1c0.3-0.1,0.6-0.3,0.9,0.2
          c0.2,0.3,0.7,0.3,1.1,0.2c0.4-0.1,0.6-0.1,0.4-0.7c-0.6-2-1.1-4-1.6-6.1c0.7,0.2,1.2,0.3,1.7,0.4c0.5,0.2,1.1,0.3,1,1.1
          c-0.1,0.3,0.1,0.8,0.8,0.8c1-0.1,2,0.2,3,0.3c0.9,0.1,1.6-0.1,2.3-0.5c-0.8-0.9-0.8-1.2,0.1-1.9c0.9-0.6,1.9-1.1,2.8-1.5
          c0.8-0.3,1.3-1,2.1-1.2c0.3-0.1,0.1-0.4,0.1-0.5c-0.6-2.7,0.4-4.3,3.1-4.8c0.5-0.1,0.6,0,0.7,0.5c0.2,1.1,0.7,1.7,1.9,1.3
          c0.4-0.1,0.5,0.2,0.6,0.4c0.3,0.5,0.6,1,1,1.4c0.4,0.5,0.8,0.9,1.6,0.7c0.5-0.1,1.4-0.2,1.1,1c-0.1,0.2-0.1,1.1,0.4,1.2
          c0.6,0.2,1.3,0,1.7-0.6c0.1-0.2,0.2-0.5,0.5-0.6c0,0.4,0.1,0.7,0.1,1.1c0,0.7,0.2,1.2,1,1.3c0.2,0,0.5,0.1,0.5,0.3
          c0.6,1.1,1.6,1,2.6,1c1.3,0,2.6,0.3,3.4,1.4c0.3,0.3,0.5,0.4,0.9,0.3c1.6-0.2,3,0.7,4.5,0.7c0.4,0,0.5,0.3,0.2,0.7
          c-1.6,2.3-2.3,4.9-1.9,7.7c0.1,0.9-0.5,1.4-1.3,1.1c-0.4-0.2-0.7,0.1-0.9,0.3c-0.2,0.3,0.4,0.3,0.2,0.7c-1.1,1.5-2.2,3-3.3,4.4
          c-0.2,0.3-0.1,0.7-0.1,1c-0.1,0.6,0,1.3-0.7,1.6c0.7,0.1,1.1,0.2,1.3-0.7c0.1-0.6,0.9-0.7,1.5-0.8c0.6-0.2,0.7,0.4,0.8,0.8
          c0.3,1.2,0.6,2.4,0.9,3.6c0.1,0.3,0.2,0.5,0.3,0.8c0.9,1.3,0.4,2.3-1.2,2.5c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.5,0.6,0.8,0.9,1.2
          c0.4,0.6,1.2,1,0.5,2.1c-0.7,1,0.5,2.3,1.8,2.4c0.4,0,0.7-0.1,1.1-0.1c0.6-0.1,0.9,0.4,0.6,0.6c-0.8,0.7-0.5,2-1.8,2.5
          c-1,0.4-2,1.4-2.5,2.6c-0.3,0.6-0.9,0.8-1.7,1c-1.1,0.3-2-0.1-3-0.2c-0.5,0-0.8-0.3-1.1-0.9c-0.4-0.6-1.3-0.3-2-0.3
          c-0.6,0-1.2,0.5-1.5-0.4c0,0-0.1-0.1-0.2-0.1c-1,0.1-2-0.6-3.1,0.1c-0.9,0.6-1.8,1.1-2.7,1.8c-0.3,0.2-0.5,0.6-1.1,0.1
          c0.8,1.5,0.1,3,1.1,4.3c-1.1-0.2-1.9,0-2.6,0.5c-0.5,0.4-1.1,0-1.5-0.3c-1.7-1-3.7-1.3-5.5-2.3c-0.4-0.2-0.9-0.3-1.5-0.5
          c0.1,1-0.4,1-1.1,1c-1.4,0-2.7-0.6-4.1-0.6c-0.1,0-0.3,0-0.3-0.1c-0.8-1.3-2.5-1.2-3.5-2.1c-0.5-0.5-0.9-1-1.6-1.3
          c-0.2-0.1-0.2-0.4,0-0.5c1.8-1.3,1.9-3.4,2.3-5.3c0.2-0.8,0.1-1.8,1.1-2.3c-0.9-0.2-0.9-0.6-0.8-1.3c0.2-1.1,0.3-2.3,0.7-3.3
          c0.2-0.5,0.4-0.5,0.7-0.1c0.4,0.3,0.5,0.8,0.8,1.2c0,0.2,0.1,0.3,0.2,0.5c-0.1-0.2-0.1-0.5-0.3-0.7c-0.2-0.4-0.3-0.8-0.5-1.1
          c-0.2-0.7-1.2-0.5-1.3-1.3c-0.3-0.7,0.9-0.9,0.7-1.6c0-0.7-0.8-0.6-1-1.2c0.2-0.2,0.6-0.1,0.8-0.5c-1.7-0.5-2.7-1.7-3.6-3.2
          c-0.2-0.4-0.3-0.8,0-1.1c0.6-0.8,0.3-1-0.5-1.1c-0.1-0.4,0.5-0.4,0.4-0.8c-0.3,0-0.5-0.1-0.8-0.1c-0.6,0-0.9-0.3-0.6-0.8
          c0.2-0.4,0.2-0.7-0.3-0.6c-0.7,0.1-1.2-0.4-1.7-0.7c-0.2,0.1-0.4,0.2-0.6,0c-0.7-1.3-2.3-1.2-3.4-1.9c-0.1-0.1-0.4-0.1-0.6,0.1
          c-0.4,0.4-0.8,0.3-0.8-0.3c0-0.6-0.5-0.8-0.8-1.2c0.1,0,0.1-0.1,0.2-0.1c0.4-0.2,1,0.1,1.2-0.3c0.2-0.5-0.6-0.4-0.9-0.7
          c0,0,0-0.1,0-0.2C4.8,19.1,5.3,19.2,5,19C4.7,18.9,4.5,18.9,4.2,19z`}
        />
        <path
          className="st0"
          d={`M18.2,34c0.3,0.7-0.5,1-0.7,1.6c-0.2-0.6-0.3-1.1-0.5-1.7c0.6-0.1,0.8,0.3,0.8,0.8
          C18.2,34.6,17.8,34.1,18.2,34z`}
        />
        <path
          className="st0"
          d={`M19.3,38.3c-0.2-0.4-0.4-0.9-0.6-1.3c0-0.1,0.1-0.1,0.1-0.2c0.4,0.2,0.6,0.6,0.7,1
          C19.6,38.1,19.7,38.3,19.3,38.3z`}
        />
        <path className="st0" d="M4.2,19c0.5-0.4,1,0,1.5,0.2c-0.3,0-0.5,0.1-0.8,0.1C4.8,18.9,4.4,19.1,4.2,19z" />
        <path className="st0" d="M10.1,23.9c0.2,0,0.4,0,0.6,0C10.5,24.2,10.2,24.8,10.1,23.9z" />
        <path className="st0" d="M51.9,25.7c0.2-0.3-0.8-0.2-0.2-0.7C51.6,25.3,52.3,25.3,51.9,25.7z" />
        <path
          className="st0"
          d="M19.3,38.3c0.2-0.1,0.2-0.3,0.2-0.5c0.3,0.4,0.2,0.8,0.2,1.3C19.3,38.9,19.4,38.5,19.3,38.3z"
        />
      </g>
    </svg>
  </>
);

export default CountryFr;
